<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
      <div class="p-3">Settlement</div>
    </div>
  </div>

  <div class="container-fluid mt-3">
    <div class="row bg-white p-3 rounded-4">
      <div class="col-md-12">

        <!-- Date Filter Form -->
        <div class="d-flex gap-3 align-items-end flex-wrap mb-4">
          <div>
            <label class="form-label small fw-semibold mb-1">Start Date</label>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" />
          </div>
          <div>
            <label class="form-label small fw-semibold mb-1">End Date</label>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" />
          </div>
          <div>
            <button class="btn btn-primary btn-sm px-4" (click)="onSubmit()">
              <i class="bi bi-search me-1"></i> Submit
            </button>
          </div>
        </div>

        <!-- Validation Error -->
        @if (error) {
          <div class="alert alert-danger py-2 small">{{ error }}</div>
        }

        <!-- Summary Cards -->
        @if (loaded) {
          <div>
            <div class="row g-3 mb-4">
              <div class="col-md-4">
                <div class="card border-0 shadow-sm rounded-4">
                  <div class="card-body">
                    <div class="text-muted small mb-1">Total Transactions</div>
                    <div class="fs-4 fw-bold text-primary">{{ totalCount }}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card border-0 shadow-sm rounded-4">
                  <div class="card-body">
                    <div class="text-muted small mb-1">Total Amount ({{ partnerCurrency || 'N/A' }})</div>
                    <div class="fs-4 fw-bold text-success">{{ totalAmount | number:'1.2-2' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Source Currency Breakdown Table -->
            <div class="card border-0 shadow-sm rounded-4 mb-4">
              <div class="card-header bg-white border-0 pt-3 pb-0">
                <h6 class="fw-semibold mb-0">Source Currency Breakdown</h6>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-hover mb-0">
                    <thead class="table-light">
                      <tr>
                        <th class="ps-3">#</th>
                        <th>Source Currency</th>
                        <th>Source Country</th>
                        <th>No. of Transactions</th>
                        <th>Total Source Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of currencySummary; track row; let i = $index) {
                        <tr>
                          <td class="ps-3 text-muted">{{ i + 1 }}</td>
                          <td><span class="badge bg-secondary">{{ row.currency }}</span></td>
                          <td>{{ row.country }}</td>
                          <td>{{ row.count }}</td>
                          <td>{{ row.amount | number:'1.2-2' }}</td>
                        </tr>
                      }
                      @if (currencySummary.length === 0) {
                        <tr>
                          <td colspan="5" class="text-center text-muted py-3">No data available</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
    </div>
  </div>
</div>
